import { QuantityCounterInputModel } from '@libs/form/models';

export const ProductBundleCounterData: QuantityCounterInputModel = {
  type: 'quantityCounter',
  label: '',
  name: 'bundleQuantity',
  attributes: {
    disabled: true,
  },
};
